import { render, staticRenderFns } from "./LiveDataDetail.vue?vue&type=template&id=73a015f8&scoped=true"
import script from "./LiveDataDetail.vue?vue&type=script&lang=js"
export * from "./LiveDataDetail.vue?vue&type=script&lang=js"
import style0 from "./LiveDataDetail.vue?vue&type=style&index=0&id=73a015f8&prod&scoped=true&lang=scss"
import style1 from "./LiveDataDetail.vue?vue&type=style&index=1&id=73a015f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a015f8",
  null
  
)

export default component.exports